import * as HoverCard from '@radix-ui/react-hover-card'
import { useState } from 'react'
import X from '../../../../assets/icon/x-icon.png'

type Props = {
  collaborator: { name: string; email: string }
  onRemove?: (email: string) => void
}

export const CollaboratorButton = ({ collaborator, onRemove }: Props) => {
  const [deleteButton, setDeleteButton] = useState<boolean>(false)
  const arrayName = collaborator.name.split(' ')
  let initial: string

  if (arrayName.length < 2) {
    initial = `${arrayName[0].substring(0, 1)}`
  } else {
    const initialArray = arrayName.map((name) => {
      return name.substring(0, 1)
    })

    initial = `${initialArray[0]}${initialArray[initialArray.length - 1]}`
  }

  return (
    <HoverCard.Root>
      <HoverCard.Trigger asChild>
        <div
          className="relative flex items-center justify-center w-8 h-8 rounded-full cursor-pointer bg-primary-light"
          onClick={(event) => {
            event.preventDefault()
            setDeleteButton(!deleteButton)
          }}
        >
          {deleteButton && onRemove && (
            <div
              className="absolute flex items-center justify-center p-1 bg-secondary-light top-[-5px] left-[18px] rounded-full z-1"
              onClick={() => onRemove && onRemove(collaborator.email)}
            >
              <img src={X} />
            </div>
          )}
          <p className="text-sm font-medium text-white ">{initial}</p>
        </div>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          className="z-50 p-2 rounded-lg bg-secondary-dark"
          sideOffset={5}
        >
          <p className="text-white  font-normal text-sm">{collaborator.name}</p>
          <HoverCard.Arrow className="fill-secondary-dark" />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}
